import TokenInfoView from './TokenInfoView'

export default TokenInfoView
